import { motion } from "framer-motion";
import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import styled from "styled-components";
import { yupResolver } from "@hookform/resolvers/yup";
import parse from "html-react-parser";
import * as Yup from "yup";
import {
  createChatCompletion,
  createTextToSpeechCompletion,
  starpilotSingleMicChatStore,
  starpilotSingleMicChatStoreResponse,
  starpilotSingleMicChatStoreTextReply,
} from "../../../api/apiHandler";
import Swal from "sweetalert2";
import AWS from "aws-sdk";
import chatLoader from "../../../assets/chatloader.gif";

import Header from "../../../components/header/Header";
import Footer from "../../../components/footer/Footer";
import constant from "../../../constant/constant";
import constantFunc from "../../../constant/constantFunc";
// import randtoken from 'rand-token'
import AudioPlayer from "react-h5-audio-player";
import ReactAudioPlayer from "react-audio-player";
import "react-h5-audio-player/lib/styles.css";
import { v4 as uuidv4 } from "uuid";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import queryString from "query-string";
import { Button, Col, Form, Row } from "react-bootstrap";
import pdficon from "../../../assets/pdf.png";
import txtIcon from "../../../assets/txtIcon.png";
import docIcon from "../../../assets/doc.png";
import xlsxIcon from "../../../assets/xlsx.jpg";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import talkto from "../../../assets/talkto.png";
import SingleMicStartilotPopup from "../../../modal/singleMicStarpilotPopup/index.js";
import AutoPrescriptionPopup from "../../../components/footer/Common/AutoPrescriptionPopup.js";

const listVariants = {
  hidden: { opacity: 0, y: 10 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.3, duration: 0.5 },
  }),
};
export default function SingleMicStarpilot({ drAiva = false }) {
  const [items, setItems] = useState([
    "STARPILOT is an autonomous doctor/expert system. Just turn on the Status and start talking or typing.",
    "StarPilot is always listening and will respond with guidance: questions, answers, suggestions, info, references and auto prescriptions. ",
  ]);
  useEffect(() => {
    const timer = setTimeout(() => {
      setItems([]); // Remove all bubbles after 1 minute
    }, 60000);

    return () => clearTimeout(timer); // Cleanup on unmount
  }, []);

  const removeBubble = (index) => {
    setItems((prevItems) => prevItems.filter((_, i) => i !== index));
  };
  const location = useParams();
  const navigate = useNavigate();
  const audioRef = useRef(null);
  const fileInputRef = useRef(null);
  // console.log("location-fgdfg->",drAiva)
  const [conversation, setConversation] = useState([]);
  const [audible, setAudible] = useState(true);
  const [storedTranscript, setStoredTranscript] = useState([]);
  // const [audioSrc, setAudioSrc] = useState("");
  const [searchValue, setSearchValue] = useState("");
  console.log("searchValue: ", searchValue);
  const [optionSelected, setOptionSelected] = useState(false);
  const [uuid, setUuid] = useState("");
  const [loadingChat, setLoadingChat] = useState(false);
  const [activeChat, setActiveChat] = useState(false);
  const [intervalId, setIntervalId] = useState(null);

  const [hints, setHints] = useState([]);
  const [audioStatus, setAudioStatus] = useState(true);
  const [image, setImage] = useState("");
  const [fileType, setFileType] = useState(null);
  const [uploadImage, setUploadImage] = useState(null);
  const [isNewchat, setIsNewChat] = useState(1);
  const [handleSweetAlert, setHandleSweetAlert] = useState(true);
  const [showListeningModal, setListeningModal] = useState(false);
  const [handleStartStopListening, setStartStopListening] = useState(true);
  const [transcriptChat, setTranscriptChat] = useState(false);
  const [instruction] = useState(constant?.auto_rx_instruction);
  const [timeoutId, setTimeoutId] = useState(null); // Store timeout ID
  const { interimTranscript, resetTranscript, transcript, listening } =
    useSpeechRecognition();

  const validationSchema = Yup.object().shape({
    prompt: Yup.string().required("prompt is required"),
  });
  const formOptions = { resolver: yupResolver(validationSchema) };
  const { register, handleSubmit, formState, reset, setValue } =
    useForm(formOptions);
  const { errors } = formState;
  const [audioData, setAudioData] = useState({
    url: "",
    text: "",
    playStatus: false,
  });
  useEffect(() => {
    SpeechRecognition.startListening({ continuous: true, timeout: 5000 });
    generateUuidIfEmpty();
    // showSweetAlert()
  }, []);

  const checkNoResponse = () => {
    // Clear previous timeout if any
    if (timeoutId) clearTimeout(timeoutId);

    const id = setTimeout(() => {
      // setConversation((prev) => [
      //   "I can't hear you, please say something or ask for help",
      //   ...prev,
      // ]);
      setAudible(false);
      console.log(
        "No response detected, showing 'I can't hear you...' message."
      );
      // checkNoResponse();
    }, 60000); // 1 min seconds timeout

    setTimeoutId(id);
  };

  const chatCreateMonteChatCompletion = () => {
    setLoadingChat(true);

    starpilotSingleMicChatStoreResponse({
      login_type_role: localStorage.getItem("user_login_type_role"),
      uuid: uuid,
    })
      .then(async (res) => {
        clearTimeout(timeoutId); // Clear timeout if response comes

        var response = JSON.parse(res);
        console.log("response===>", response.data.response);

        if (response.code == process.env.REACT_APP_SUCCESS) {
          if (response.data.response) {
            let newMsgT = await constantFunc.convertMarkdownLinksToHTML(
              response.data.response
            );
            let chatObj = {
              response: newMsgT,
              time: response.data.chatHistory2[0].time,
            };
            console.log(
              "response.data.chatHistory-->",
              response.data.chatHistory
            );

            if (
              response?.data?.chatHistory2 &&
              response?.data?.chatHistory2.length > 0
            ) {
              setConversation((prev) => [
                ...response.data.chatHistory2,
                ...prev,
              ]);
            } else {
              setConversation((prev) => [chatObj, ...prev]);
            }
            setAudible(true);
            checkNoResponse(); // Restart the 30-sec no-response check
          }
        } else {
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: response.message,
            toast: true,
            showConfirmButton: false,
            timer: 2000,
          });
        }

        setLoadingChat(false);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setConversation((prev) => [
          "Something went wrong. Please check your internet connection.",
          ...prev,
        ]);
        setLoadingChat(false);
      });
  };

  useEffect(() => {
    if (activeChat) {
      const id = setInterval(() => {
        chatCreateMonteChatCompletion();
      }, 10000); // 10 seconds interval for API calls

      setIntervalId(id);
      checkNoResponse(); // Start first no-response check

      return () => {
        clearInterval(id);
        setIntervalId(null);
        clearTimeout(timeoutId);
        setTimeoutId(null);
      };
    }
  }, [activeChat]);

  const generateUuidIfEmpty = () => {
    if (!uuid) {
      // const newUuid = randtoken.generate(16, "abcdefghijklnmopqrstuvwxyz");
      const newUuid = uuidv4();
      console.log("Generated uuid:", newUuid);
      setUuid(newUuid);
    }
  };

  const showSweetAlert = () => {
    Swal.fire({
      title: `Hello Dr. ${localStorage.getItem(
        "user_name"
      )}, How are you today?`,
      imageUrl: `${process.env.PUBLIC_URL + "/assets/images/logo.png"}`,
      imageWidth: 150,
      imageHeight: 120,
      showCancelButton: true,
      confirmButtonText: "I'm feeling great",
      cancelButtonText: "I'm doing okay",
    }).then((result) => {
      setHandleSweetAlert(false);
      if (result.isConfirmed) {
        handleOptionSelection("Option 1");
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        handleOptionSelection("Option 2");
      }
    });
  };

  const handleOptionSelection = (option) => {
    console.log(`User selected option: ${option}`);
    setOptionSelected(true);
    Swal.fire({
      title: "Please wait...",
      didOpen: () => {
        Swal.showLoading();
      },
    });
  };

  const onSubmit = async (data) => {
    if (!uploadImage) {
      console.log("searchValue-dsf-->", searchValue);
      pocCreateChatCompletion(data.prompt, uuid);
      setSearchValue("");
    } else {
      console.log("data: ");
      let imgUrl = "";
      await uploadData(uploadImage, "/analysis_file")
        .then((newImage) => {
          Swal.close();
          console.log("newImagenewImagenewImage", newImage);
          imgUrl = newImage;
        })
        .catch((e) => {
          Swal.close();
        });
      // poccreateChatAnalysisCompletion(imgUrl)
      pocCreateChatCompletion(
        data.prompt,
        uuid,
        `https://msh-dev.s3.amazonaws.com/analysis_file/${imgUrl}`
      );
    }
  };
  const handleAudioEnd = () => {
    // console.log('Audio has ended');
    setAudioData((prev) => ({ ...prev, playStatus: false }));
    // Add any additional logic you want to execute when audio ends here
  };

  const stopAudio = () => {
    // console.log('Audio has Stoped');
    setAudioData((prev) => ({ ...prev, playStatus: false }));
    audioRef.current.pause();
    audioRef.current.currentTime = 0; // Resets audio to the start
  };

  const onSubmitBtn = async (data) => {
    try {
      console.log("onSubmitBtn", data);
      setActiveChat(data);
    } catch (e) {
      console.log("error-->", e);
    }
  };

  useEffect(() => {
    let interval;
    console.log("transcript-->", transcript);
    if (transcript) {
      console.log("transcript: ", transcript);
      checkNoResponse();
      setAudible(true);
      const activeUserObj = {
        login_type_role: localStorage.getItem("user_login_type_role"),
        prompt: transcript,
        uuid: uuid,
      };
      console.log("activeUserObj: ", activeUserObj);

      interval = setInterval(() => {
        console.log("activeUserObj: ", activeUserObj);
        starpilotSingleMicChatStore(activeUserObj)
          .then((response) => {
            response = JSON.parse(response);
            // console.log('response: ', response);
            resetTranscript();
            if (response.code == process.env.REACT_APP_SUCCESS) {
              // console.log("response.data==>", response.data)
              setStoredTranscript(response.data);
            } else {
              Swal.fire({
                position: "top-end",
                icon: "error",
                title: response.message,
                toast: true,
                showConfirmButton: false,
                timer: 2000,
              });
            }
          })
          .catch((error) => {
            resetTranscript();
            console.log("error", error);
          });
      }, 3000);
    }
    return () => clearInterval(interval);
  }, [transcript, resetTranscript]);

  const handleAudio = async () => {
    setAudioStatus(!audioStatus);
    if (!audioStatus) {
      // Unmute and select default audio input
      SpeechRecognition.startListening({ continuous: true, timeout: 5000 });
    } else {
      SpeechRecognition.stopListening();
    }
  };

  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      console.log("event.target.files[0]==>", event.target.files[0]);
      const allowedTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "application/pdf",
        "text/plain",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ];
      if (allowedTypes.includes(event.target.files[0].type)) {
        const fileSizeLimit = 10 * 1024 * 1024;
        if (event.target.files[0].size > fileSizeLimit) {
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: "File size exceeds the limit of 10 MB",
            toast: true,
            showConfirmButton: false,
            timer: 3000,
          });
        } else {
          setImage(URL.createObjectURL(event.target.files[0]));
          console.log("event.target.files[0]-->", event.target.files[0]);
          setUploadImage(event.target.files[0]);
          if (event.target.files[0].type == "application/pdf") {
            setFileType("pdf");
          } else if (event.target.files[0].type == "text/plain") {
            setFileType("text");
          } else if (
            event.target.files[0].type ==
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          ) {
            setFileType("doc");
          } else if (
            event.target.files[0].type ==
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          ) {
            setFileType("xlsx");
          } else {
            setFileType("image");
          }
        }
      } else {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title:
            "Only Image File(png, jpeg, jpg, PDF, Text, docx, xlsx) Type Allowed!",
          toast: true,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    }
  };

  const uploadData = async (file, folder_type) => {
    const S3_BUCKET = process.env.REACT_APP_AWS_S3_NAME;
    const REGION = process.env.REACT_APP_AWS_S3_REGION;

    AWS.config.update({
      accessKeyId: process.env.REACT_APP_AWS_S3_ACCESS_KEY,
      secretAccessKey: process.env.REACT_APP_AWS_S3_SECRET_KEY,
      region: REGION,
    });
    const ext = file.name.split(".").pop();
    const s3 = new AWS.S3({
      params: { Bucket: S3_BUCKET },
      region: REGION,
    });

    try {
      const newFileName = new Date().getTime() + "." + ext;
      const params = {
        Bucket: S3_BUCKET + folder_type,
        Key: newFileName,
        Body: file,
        ACL: "public-read",
      };

      return new Promise((resolve, reject) => {
        s3.putObject(params, (err, data) => {
          console.log("err, data-->", err, data);
          if (err) {
            reject(err);
          } else {
            resolve(newFileName);
          }
        });
      });
    } catch (error) {
      console.error("Error in UploadData:", error);
    }
  };

  const pocCreateChatCompletion = (prompt, uuid, image = "") => {
    Swal.fire({
      title: "Please wait...",
      didOpen: () => {
        Swal.showLoading();
      },
    });
    console.log("image-->", image);
    starpilotSingleMicChatStoreTextReply({
      prompt: prompt,
      uuid: uuid,
      imgType: fileType,
      imgUrl: image,
      login_type_role: parseInt(localStorage.getItem("user_login_type_role")),
    }).then(async (res) => {
      console.log("response===>", res);
      var response = JSON.parse(res);
      console.log("response= response==>", response);

      if (response.code == process.env.REACT_APP_SUCCESS) {
        setIsNewChat(0);
        if (fileInputRef.current) {
          fileInputRef.current.value = ""; // Clear the input field
        }
        setImage("");
        setUploadImage(null);
        setFileType("");
        setIsNewChat(0);
        setConversation([]);
        setSearchValue("");
        reset();
        const responseData = response.data.response;
        if (response.data.response) {
          let newMsgT = await constantFunc.convertMarkdownLinksToHTML(
            response.data.response
          );
          let chatObj = {
            response: newMsgT,
            time: response.data.chatHistory2[0].time,
          };
          console.log(
            "response.data.chatHistory-->",
            response.data.chatHistory
          );
          if (
            response?.data?.chatHistory2 &&
            response?.data?.chatHistory2.length > 0
          ) {
            setConversation((prev) => [...response.data.chatHistory2, ...prev]);
          } else {
            setConversation((prev) => [chatObj, ...prev]);
          }
        }
      } else {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: response.message,
          toast: true,
          showConfirmButton: false,
          timer: 2000,
        });
      }
      Swal.close();
    });
  };

  const openListeningModal = () => {
    setListeningModal(true);
  };
  const autoPresc = async () => {
    try {
      const meetingDataObj = {
        uuid: uuid,
      };
      const serializedObject = queryString.stringify(meetingDataObj);
      const url = `/doctor/auto-prescription-starpilot?${serializedObject}`;
      setTimeout(() => {
        window.open(url, "_blank");
      }, 500);
    } catch (error) {}
  };

  const pocCreateTextToSpeechCompletion = (msg) => {
    if (audioData?.text && audioData?.text == msg) {
      setAudioData((prev) => ({ ...prev, playStatus: true }));
      audioRef.current.src = audioData?.url;
      audioRef.current.controls = true;
      audioRef.current.play();
    } else {
      Swal.fire({
        title: "Please wait...",
        didOpen: () => {
          Swal.showLoading();
        },
      });
      createTextToSpeechCompletion({ text: msg }).then((res) => {
        // console.log('response===>', res)
        var response = JSON.parse(res);
        if (response.code == process.env.REACT_APP_SUCCESS) {
          const arrayBuffer = response.data.buffer.data;
          console.log("arrayBuffer==>", arrayBuffer);
          // Convert buffer data to Blob
          const byteArray = new Uint8Array(arrayBuffer);
          const blob = new Blob([byteArray], { type: "audio/mpeg" });
          // const blob = new Blob([arrayBuffer], { type: 'audio/mp3' });
          const url = URL.createObjectURL(blob);
          // setAudioSrc(url)
          // const audio = new Audio(url);
          console.log("url==>", url);
          if (audioRef.current) {
            console.log("test");
            audioRef.current.src = url;
            audioRef.current.controls = true;
            audioRef.current.play();
            setAudioData({
              url: url,
              text: msg,
              playStatus: true,
            });
          } else {
            // console.log("testfsed")
          }
        } else {
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: response.message,
            toast: true,
            showConfirmButton: false,
            timer: 2000,
          });
        }
        if (!handleSweetAlert) {
          Swal.close();
        }
      });
    }
  };

  const closeListeningModal = () => {
    SpeechRecognition.stopListening();
    resetTranscript();
    setStartStopListening(true);
    setListeningModal(false);
    setValue("prompt", searchValue, { shouldValidate: false });
  };

  const handleListening = () => {
    if (handleStartStopListening) {
      SpeechRecognition.startListening({ continuous: true, timeout: 5000 });
      setStartStopListening(false);
    } else {
      // SpeechRecognition.stopListening();
      // resetTranscript()
      // setStartStopListening(true)
      closeListeningModal();
    }
  };

  // useEffect(() => {
  //   let timeout;
  //   if (transcript) {
  //     console.log('transcript: ', transcript);

  //     clearTimeout(timeout);
  //     timeout = setTimeout(() => {
  //       setSearchValue(transcript);
  //     }, 1000);
  //   } else {
  //     console.log("transscrpt functirn calluued");
  //   }
  //   return () => clearTimeout(timeout);
  // }, [transcript, resetTranscript]);
  const emptyImage = async () => {
    try {
      if (fileInputRef.current) {
        fileInputRef.current.value = ""; // Clear the input field
      }
      setImage("");
      setUploadImage(null);
      setFileType("");
    } catch (error) {}
  };
    const handleLeave = () => {
         Swal.fire({
            icon: "warning",
            title: "Exit Meeting",
            text: "Are you sure you want to exit the meeting?",
            showCancelButton: true,
            confirmButtonText: "Yes, Exit",
            cancelButtonText: "Cancel",
          }).then(async (result) => {
            if (result.isConfirmed) {
              // await meetingManager.leave();
              // SpeechRecognition.stopListening();
              navigate("/doctor/home")
            } else {
            }
          });
    }
  return (
    <>
      {transcriptChat && (
        <SingleMicStartilotPopup
          transcriptChat={transcriptChat}
          setTranscriptChat={setTranscriptChat}
          storedTranscript={storedTranscript}
        />
      )}

      <Header />
      <section className="search-sec py-4">
        <form
          className="form-horizontal m-t-30"
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className="container">
            <div
              className="border bg-white"
              style={{
                borderTopLeftRadius: 20,
                borderTopRightRadius: 20,
                borderBottomRightRadius: 8,
                borderBottomLeftRadius: 8,
              }}
            >
              <div
                className="top position-relative d-flex align-items-center justify-content-center p-3 "
                style={{
                  background: "rgb(33, 111, 200)",
                  borderTopLeftRadius: 20,
                  borderTopRightRadius: 20,
                }}
              >
                <LabelTag
                  className="position-absolute fw-bold px-3 text-white py-1 "
                  style={{
                    background: "#ff8115",
                    borderTopLeftRadius: "5px",
                    borderBottomLeftRadius: "5px",
                  }}
                >
                  1-Mic
                </LabelTag>
                <div
                  className="flex-shrink-0 imgWrp me-3 d-flex align-items-center p-3                                       justify-content-center bg-white rounded-circle"
                  style={{ height: 100, width: 100 }}
                >
                  <img
                    src={talkto}
                    alt=""
                    className="img-fluid rounded object-fit-contain h-100"
                  />
                </div>
                <div
                  className="content text-center"
                  style={{ fontFamily: "Aharoni" }}
                >
                  <h2
                    className="m-0 fw-bold text-white"
                    style={{ fontSize: 50, lineHeight: "40px" }}
                  >
                    {"Starpilot"}
                  </h2>
                  <h5 className="m-0 text-white mt-1">Concierge</h5>
                </div>
              </div>
              <Row>
                <Col lg="12" className="">
                  <div className="">
                    <div className="form-horizontal bg-light py-2 position-relative">
                      {loadingChat && (
                        <img
                          src={chatLoader}
                          style={{ left: 10, top: 20, height: 20 }}
                          alt=""
                          className="img-fluid position-absolute"
                        />
                      )}
                      <div
                        className="container py-3 border rounded-3"
                        style={{ maxWidth: 600 }}
                      >
                        <div className="d-flex gap-2">
                          {/* <div className="input-group p-1 rounded">
                        <span className="input-group-text d-flex align-items-center justify-content-center p-0" style={{ fontSize: 12, height: 30, width: 30 }} id="basic-addon1">
                          <i className="fa-solid fa-magnifying-glass"> </i>
                        </span>
                        <input
                          type="text"
                          style={{ fontSize: 12 }}
                          name="prompt"
                          className="form-control"
                          id="prompt"
                          placeholder=" Send your message..."
                          value={searchValue}
                          onChange={(e) => { setSearchValue(e.target.value) }}
                          disabled={loadingChat}
                        />
                        <div className="invalid-feedback" />
                      </div> */}
                          <MainBtnWrpper className="d-flex align-items-center justify-content-between w-100 ">
                            <div
                              className="d-flex gap-2 status"
                              style={{ alignItems: "center" }}
                            >
                              {/* <button
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Send" disabled={loadingChat} className="search-btn p-2 rounded" onClick={onSubmitChat} type="button">
                          <img src="/assets/images/icon/send1.svg" alt="search" />
                        </button>
                        <button data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="mike" disabled={loadingChat} onClick={openListeningModal} className="search-btn p-2 rounded" type="button">
                          <img
                            src="/assets/images/icon/mdi_microphone.svg"
                            alt="microphone"
                          />
                        </button>
                        <button type="button"
                          onClick={() => {
                            setIsNewChat(1);
                            resetChat()
                          }}
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Start Again" className="search-btn p-2 rounded"  >
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                            <path d="M22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2V4C10.0845 4.00022 8.23272 4.6877 6.78115 5.93749C5.32958 7.18727 4.37462 8.9164 4.08983 10.8106C3.80504 12.7048 4.20934 14.6382 5.22923 16.2596C6.24912 17.881 7.81691 19.0826 9.64763 19.646C11.4783 20.2095 13.4505 20.0974 15.2055 19.3301C16.9606 18.5628 18.3821 17.1913 19.2117 15.4648C20.0413 13.7382 20.2239 11.7714 19.7262 9.9217C19.2286 8.07199 18.0839 6.46223 16.5 5.385V8H14.5V2H20.5V4H18C19.2425 4.93093 20.251 6.13866 20.9453 7.52734C21.6397 8.91601 22.0008 10.4474 22 12Z" fill="#fff" />
                          </svg>
                        </button> */}
                              <label
                                htmlFor="custom-switch"
                                className="d-block mb-0 p-0 nav-link active"
                              >
                                Status
                              </label>
                              <Form.Check // prettier-ignore
                                type="switch"
                                id="custom-switch"
                                onChange={(x) => onSubmitBtn(x.target.checked)}
                                checked={activeChat}
                              />
                            </div>
                            <div
                              className="right d-flex align-items-center gap-10 meeting-widgets"
                              style={{ flex: "unset" }}
                            >
                              {activeChat && (
                                <p className="m-0 fw-sbold">
                                  Listening{" "}
                                  <img
                                    src={chatLoader}
                                    style={{ height: 20 }}
                                    alt=""
                                    className="img-fluid"
                                  />
                                </p>
                              )}
                              <div
                                className="mute-widget"
                                style={{ background: "#216fc8" }}
                                onClick={() => setTranscriptChat(true)}
                              >
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M3 6C3 5.46957 3.21071 4.96086 3.58579 4.58579C3.96086 4.21071 4.46957 4 5 4H19C19.5304 4 20.0391 4.21071 20.4142 4.58579C20.7893 4.96086 21 5.46957 21 6V15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H12.384L9.504 19.592C8.537 20.461 7 19.776 7 18.477V17H5C4.46957 17 3.96086 16.7893 3.58579 16.4142C3.21071 16.0391 3 15.5304 3 15V6ZM7 8C6.73478 8 6.48043 8.10536 6.29289 8.29289C6.10536 8.48043 6 8.73478 6 9C6 9.26522 6.10536 9.51957 6.29289 9.70711C6.48043 9.89464 6.73478 10 7 10H12C12.2652 10 12.5196 9.89464 12.7071 9.70711C12.8946 9.51957 13 9.26522 13 9C13 8.73478 12.8946 8.48043 12.7071 8.29289C12.5196 8.10536 12.2652 8 12 8H7ZM15 8C14.7348 8 14.4804 8.10536 14.2929 8.29289C14.1054 8.48043 14 8.73478 14 9C14 9.26522 14.1054 9.51957 14.2929 9.70711C14.4804 9.89464 14.7348 10 15 10H17C17.2652 10 17.5196 9.89464 17.7071 9.70711C17.8946 9.51957 18 9.26522 18 9C18 8.73478 17.8946 8.48043 17.7071 8.29289C17.5196 8.10536 17.2652 8 17 8H15ZM7 11C6.73478 11 6.48043 11.1054 6.29289 11.2929C6.10536 11.4804 6 11.7348 6 12C6 12.2652 6.10536 12.5196 6.29289 12.7071C6.48043 12.8946 6.73478 13 7 13H9C9.26522 13 9.51957 12.8946 9.70711 12.7071C9.89464 12.5196 10 12.2652 10 12C10 11.7348 9.89464 11.4804 9.70711 11.2929C9.51957 11.1054 9.26522 11 9 11H7ZM12 11C11.7348 11 11.4804 11.1054 11.2929 11.2929C11.1054 11.4804 11 11.7348 11 12C11 12.2652 11.1054 12.5196 11.2929 12.7071C11.4804 12.8946 11.7348 13 12 13H17C17.2652 13 17.5196 12.8946 17.7071 12.7071C17.8946 12.5196 18 12.2652 18 12C18 11.7348 17.8946 11.4804 17.7071 11.2929C17.5196 11.1054 17.2652 11 17 11H12Z"
                                    fill="#fff"
                                  />
                                </svg>
                              </div>

                              <div
                                className="mute-widget"
                                style={{ background: "#216fc8" }}
                              >
                                <i
                                  onClick={handleAudio}
                                  className={
                                    audioStatus
                                      ? "fa-solid fa-microphone"
                                      : "fa-solid fa-microphone-slash"
                                  }
                                />
                              </div>

                              {/* <OverlayTrigger
                              placement="top"
                              delay={{ show: 250, hide: 400 }}
                              overlay={
                                <Tooltip id="button-tooltip">
                                  <ul
                                    style={{
                                      margin: 0,
                                      padding: 0,
                                      listStyleType: "none",
                                    }}
                                  >
                                    <li
                                      style={{ textAlign: "left" }}
                                    >
                                    </li>
                                  </ul>
                                </Tooltip>
                              }
                            > */}
                              <AutoPrescriptionPopup
                                instruction={instruction}
                                onConfirm={autoPresc}
                              />

                              {/* </OverlayTrigger> */}

                              <button
                                className={
                                  true ? "leave-btn" : "leave-btn-disable"
                                }
                                onClick={handleLeave}
                              >
                                Leave
                              </button>
                            </div>
                          </MainBtnWrpper>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className=" form-horizontal bg-white  position-relative py-4 px-3">
                    <div className="d-flex justify-content-center align-items-center gap-2">
                      <div
                        className="position-relative p-3 rounded w-100"
                        style={{ border: "2px dashed #9d9d9d", maxWidth: 400 }}
                      >
                        {image && (
                          <Button
                            onClick={emptyImage}
                            className="border-0 position-absolute text-white  rounded-circle p-2 d-flex align-items-center justify-content-center"
                            style={{
                              top: 0,
                              right: 0,
                              zIndex: 999,
                              transform: "translateY(-50%)",
                              background: "#216fc8",
                              height: 30,
                              width: 30,
                            }}
                            variant="transparent"
                          >
                            X
                          </Button>
                        )}
                        <input
                          type="file"
                          ref={fileInputRef}
                          onChange={onImageChange}
                          style={{ left: 0, top: 0, zIndex: 99, opacity: 0 }}
                          className="position-absolute h-100 w-100 file"
                        />
                        <div className="text-center">
                          {image && (
                            <img
                              src={
                                (fileType == "pdf" && pdficon) ||
                                (fileType == "text" && txtIcon) ||
                                (fileType == "doc" && docIcon) ||
                                (fileType == "xlsx" && xlsxIcon) ||
                                image
                              }
                              alt=""
                              className="img-fluid mx-auto object-fit-contain"
                              style={{ height: 100, width: 100 }}
                            />
                          )}
                          <p className="m-0 text-muted">Upload File</p>
                          <p
                            className="m-0 text-muted"
                            style={{ fontSize: 10 }}
                          >
                            Upload File for Analysis
                          </p>
                        </div>
                      </div>
                      {/* <button className="search-btn" type="button" onClick={onSubmit12}>
                <img src={process.env.PUBLIC_URL + "/assets/images/icon/send1.svg"} alt="search" />
              </button> */}
                    </div>
                  </div>
                  <div className="d-flex gap-2 bg-white px-3 pb-3">
                    <div className="input-group rounded-0">
                      <span className="input-group-text" id="basic-addon1">
                        <i className="fa-solid fa-magnifying-glass"> </i>
                      </span>
                      <input
                        type="text"
                        {...register("prompt")}
                        className="form-control"
                        id="prompt"
                        value={searchValue}
                        placeholder={
                          parseInt(location.poc_type) == 7
                            ? "Hello I have a fever and a headache and some fatigue. What might be the problem? what do you need for accurate differential diagnosis?"
                            : parseInt(location.poc_type) == 2
                            ? "Please check the following prescription for interactions and indications. Please revise the prescription to remove interactions and ameliorate severe indications."
                            : " Send your message..."
                        }
                        onChange={(e) => {
                          setSearchValue(e.target.value);
                        }}
                      />
                      <div className="invalid-feedback">
                        {errors.prompt?.message}
                      </div>
                      {activeChat && !audible && (
                        <>
                          <div className="invalid-feedback">
                            {
                              "I can't hear you, please say something or ask for help"
                            }
                          </div>
                        </>
                      )}
                    </div>
                    <div className="d-flex gap-2">
                      <button className="search-btn" type="submit">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/images/icon/send1.svg"
                          }
                          alt="search"
                        />
                      </button>
                    </div>
                  </div>
                  <div className="py-2">
                    <ul
                      className="list-unstyled px-3 mb-0 d-flex align-items-center gap-3 overflow-auto"
                      style={{ fontSize: 12 }}
                    >
                      {items.map((text, index) => (
                        <motion.li
                          key={index}
                          className="p-1 flex-shrink-0"
                          initial="hidden"
                          animate="visible"
                          exit="exit"
                          custom={index}
                          variants={listVariants}
                        >
                          <div
                            className=" d-inline-flex h-auto pb-2 pt-3 px-3 rounded-4 shadow commonBtn position-relative"
                            style={{ width: 200 }}
                          >
                            <button
                              onClick={() => removeBubble(index)}
                              type="button"
                              className="border-0 position-absolute p-0 text-white bg-transparent"
                              style={{ fontSize: 10, top: 5, right: 5 }}
                            >
                              X
                            </button>
                            {text}
                          </div>
                        </motion.li>
                      ))}
                    </ul>
                  </div>
                  {hints?.length > 0 && (
                    <div className=" overflow-auto d-flex align-items-center justify-content-cednter mb-2 gap-10 px-4 w-100">
                      {hints?.length > 0 &&
                        hints?.map((itm) => (
                          <OverlayTrigger
                            placement="top"
                            delay={{ show: 250, hide: 400 }}
                            overlay={
                              <Tooltip id="button-tooltip">{itm}</Tooltip>
                            }
                          >
                            <div
                              onClick={() => {
                                setSearchValue(itm);
                                setValue("prompt", itm);
                              }}
                              className="d-block py-2 align-items-center justify-content-center btn commonBtn text-truncate px-3 rounded-pill"
                              style={{
                                maxWidth: 300,
                                fontSize: 12,
                                flexShrink: 0,
                              }}
                            >
                              {itm}{" "}
                            </div>
                          </OverlayTrigger>
                        ))}
                    </div>
                  )}
                  <div className="ans-block border-0">
                    {conversation.map((entry, index) => (
                      <div key={index}>
                        <div className="ans-sub-block border-0">
                          <div className="bg-[#040404] rounded-lg  mb-2 overflow-auto subblock">
                            <div className="aiicon">
                              <img
                                src={
                                  process.env.PUBLIC_URL +
                                  "/assets/images/logo.png"
                                }
                                alt="profile"
                                className="profile"
                              />
                            </div>
                            <div>
                              <p className="mb-2 font_16 text-blue font_600">
                                <span>Monte Sereno</span>
                                <span className="ms-2 d-inline-block text-gray-500 font_400">
                                  ({new Date(entry?.time).toUTCString()})
                                </span>
                              </p>
                              <pre className="mb-2 text-justify white-space-pre">
                                {parse(entry.response)}
                              </pre>
                              {/* <button className="search-btn" type="button" onClick={()=>{
                          pocCreateTextToSpeechCompletion(entry.message)
                        }}>
                          <i className="fa-solid fa-volume-up text-white" ></i>
                        </button> */}

                              {(audioData?.playStatus &&
                                audioData?.text == parse(entry) && (
                                  <button
                                    className="search-btn"
                                    type="button"
                                    onClick={() => {
                                      stopAudio();
                                    }}
                                  >
                                    <i className="fa-solid fa-pause text-white" />
                                  </button>
                                )) || (
                                <button
                                  className="search-btn"
                                  type="button"
                                  onClick={() => {
                                    pocCreateTextToSpeechCompletion(
                                      parse(entry)
                                    );
                                  }}
                                >
                                  <i className="fa-solid fa-volume-up text-white" />
                                </button>
                              )}
                              <audio
                                onEnded={handleAudioEnd}
                                style={{ height: 0, width: 0, opacity: 0 }}
                                ref={audioRef}
                                controls
                              >
                                <source src="" type="audio/mpeg" />
                              </audio>
                              {/* <AudioPlayer
                          autoPlay
                          src="https://commondatastorage.googleapis.com/codeskulptor-demos/DDR_assets/Kangaroo_MusiQue_-_The_Neverwritten_Role_Playing_Game.mp3"
                          onPlay={e => console.log("onPlay")}
                        // other props here
                        /> */}
                              {/* <ReactAudioPlayer
                          src="https://commondatastorage.googleapis.com/codeskulptor-demos/DDR_assets/Kangaroo_MusiQue_-_The_Neverwritten_Role_Playing_Game.mp3"
                          autoPlay={true}
                          controls
                        /> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </form>
      </section>
      <Footer />

      {showListeningModal && (
        <>
          <div
            className={`modal fade ${showListeningModal ? "show" : ""}`}
            id="staticBackdrop1"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
            tabIndex="-1"
            style={{ display: showListeningModal ? "block" : "none" }}
          >
            <div className="modal-dialog prescription-modal modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header border-0">
                  <h5 className="modal-title" id="staticBackdropLabel">
                    Listening
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={closeListeningModal}
                  />
                </div>
                <div className="modal-body">
                  <div className="text-center">
                    {!handleStartStopListening ? (
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/icon/icons8-sound.gif"
                        }
                        alt="search"
                      />
                    ) : (
                      ""
                    )}
                  </div>
                  {/* <div className="d-flex gap-3">
                        <pre className="mb-2 text-justify white-space-pre">{searchValue}</pre>
                      </div> */}
                </div>
                <div className="modal-footer">
                  {/* <button type="button" className="btn btn-secondary" onClick={handleListening}>{handleStartStopListening ? "Start" : "Stop"}</button> */}
                  <button
                    type="button"
                    className="btn submit-btn font_18"
                    onClick={handleListening}
                  >
                    {handleStartStopListening ? "Start" : "Stop"}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )}
    </>
  );
}

const LabelTag = styled.div`
  right: 0;
  @media (max-width: 575px) {
    bottom: 0;
  }
`;

const MainBtnWrpper = styled.div``;
